import { Action } from 'redux';
import { CoverItem, ShoppingItem } from 'sofa-reborn-react';

// State
export interface CoverState {
	coverItems: CoverItem[];
	replaceCoverItems: CoverItem[];
	selectedCover: CoverItem | null;
	missingCover: boolean;
	notPreloadedCovers: string[] | null;
	coverOnly?: boolean;
	coverOnlyItems: CoverItem[];
	additionalCoverItems: ShoppingItem[];
}

// Actions
export const SET_SELECTED_COVER = 'SET_SELECTED_COVER';
export const SET_COVER_ITEMS = 'SET_COVER_ITEMS';
export const SET_REPLACE_COVER_ITEMS = 'SET_REPLACE_COVER_ITEMS';
export const SHOW_COVER_PRODUCT_DESCRIPTION = 'SHOW_COVER_PRODUCT_DESCRIPTION';
export const SET_MISSING_COVER = 'SET_MISSING_COVER';
export const SET_NOT_PRELOADED_COVERS = 'SET_NOT_PRELOADED_COVERS';
export const SET_COVER_ONLY = 'SET_COVER_ONLY';
export const SET_COVER_ONLY_SWITCH = 'SET_COVER_ONLY_SWITCH';
export const SET_COVER_ONLY_ITEMS = 'SET_COVER_ONLY_ITEMS';
export const ADD_ADDITIONAL_COVER = 'ADD_ADDITIONAL_COVER';
export const SET_ADDITIONAL_COVER_ITEMS = 'SET_ADDITIONAL_COVER_ITEMS';
export const ADDITIONAL_COVER_ITEM_REMOVED = 'ADDITIONAL_COVER_ITEM_REMOVED';
export const ADDITIONAL_COVER_ITEM_CLICKED = 'ADDITIONAL_COVER_ITEM_CLICKED';
export const CLEAR_ADDITIONAL_COVER_ITEMS = 'CLEAR_ADDITIONAL_COVER_ITEMS';
export const ADDITIONAL_COVER_CLOSED = 'ADDITIONAL_COVER_CLOSED';

interface SetSelectedCover extends Action {
	type: typeof SET_SELECTED_COVER;
	value: CoverItem;
	origin: 'product-intro-gallery' | 'cover-picker';
}

interface SetCoverItems extends Action {
	type: typeof SET_COVER_ITEMS;
	value: CoverItem[];
}

interface SetReplaceCoverItems extends Action {
	type: typeof SET_REPLACE_COVER_ITEMS;
	value: CoverItem[];
}

interface ShowCoverProductDescription extends Action {
	type: typeof SHOW_COVER_PRODUCT_DESCRIPTION;
	value: boolean;
}

interface SetMissingCover extends Action {
	type: typeof SET_MISSING_COVER;
	value: boolean;
}

interface SetNotPreloadedCovers extends Action {
	type: typeof SET_NOT_PRELOADED_COVERS;
	value: string[] | null;
}

interface SetCoverOnly extends Action {
	type: typeof SET_COVER_ONLY;
	value: boolean;
}

interface SetCoverOnlyItems extends Action {
	type: typeof SET_COVER_ONLY_ITEMS;
	value: CoverItem[];
}

interface AddAdditionalCover extends Action {
	type: typeof ADD_ADDITIONAL_COVER;
	coverName: string;
}

interface SetAdditionalCoverItems extends Action {
	type: typeof SET_ADDITIONAL_COVER_ITEMS;
	value: ShoppingItem[];
}

interface AdditionalCoverItemClicked extends Action {
	type: typeof ADDITIONAL_COVER_ITEM_CLICKED;
	value: string;
}

interface AdditionalCoverItemRemoved extends Action {
	type: typeof ADDITIONAL_COVER_ITEM_REMOVED;
	article: string;
}

interface ClearAdditionalCoverItems extends Action {
	type: typeof CLEAR_ADDITIONAL_COVER_ITEMS;
}

interface CloseAdditionalCover extends Action {
	type: typeof ADDITIONAL_COVER_CLOSED;
}

export type CoverStateActions =
	| SetSelectedCover
	| SetCoverItems
	| SetReplaceCoverItems
	| ShowCoverProductDescription
	| SetMissingCover
	| SetNotPreloadedCovers
	| SetCoverOnly
	| SetCoverOnlyItems
	| AddAdditionalCover
	| SetAdditionalCoverItems
	| AdditionalCoverItemClicked
	| AdditionalCoverItemRemoved
	| ClearAdditionalCoverItems
	| CloseAdditionalCover;
